export const Pop = "pop";
export const Pulse = (_color: string) => "pulse";
export const Alert = "alertFlash";
export const blinker = () => "blinker";
export const Danger = "dangerFlash";
